import { EQUIPMENT_PRODUCERS_ENDPOINT } from "../../../../consts";
import { useCRUD } from "../../../../api/crud";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Typography, Chip } from "@mui/material";
import FactoryOutlinedIcon from "@mui/icons-material/FactoryOutlined";
import { useTranslation } from "react-i18next";
import { useBreadcrumbs } from "../../../../components/ui/breadcrumps/breadcrumbsContext";
import {
  DetailHeader,
  DetailPage,
  DetailRow,
  DetailSection,
} from "../../../../components/ui/detailView";

interface ProducerModel {
  id: number;
  name: string;
  display_name?: string;
}

interface Producer {
  id: number;
  name: string;
  models?: ProducerModel[];
}

export const ProducerBasicInfo = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { get } = useCRUD(EQUIPMENT_PRODUCERS_ENDPOINT);
  const { setOverride } = useBreadcrumbs();
  const [producer, setProducer] = useState<Producer | null>(null);

  useEffect(() => {
    const fetchProducer = async () => {
      if (id) {
        const response = await get(id);
        if (response?.data) {
          setProducer(response.data);
          setOverride(
            `/equipment-section/producers/${id}`,
            (response.data as Producer).name || id
          );
        }
      }
    };

    const handleProducerUpdated = () => {
      fetchProducer();
    };

    window.addEventListener("equipmentProducerUpdated", handleProducerUpdated);
    fetchProducer();
    return () => {
      window.removeEventListener("equipmentProducerUpdated", handleProducerUpdated);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!producer) return <DetailPage loading />;

  const models = Array.isArray(producer.models) ? producer.models : [];

  return (
    <DetailPage>
      <DetailHeader icon={<FactoryOutlinedIcon />} title={producer.name} />

      <DetailSection title={t("Basic Information")}>
        <DetailRow label={t("Name")} value={producer.name} />
      </DetailSection>

      <DetailSection title={t("Models")} padded>
        {models.length > 0 ? (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {models.map((model) => (
              <Chip key={model.id} label={model.name} size="small" variant="outlined" />
            ))}
          </Box>
        ) : (
          <Typography variant="body2" color="text.secondary" fontStyle="italic">
            {t("No models assigned")}
          </Typography>
        )}
      </DetailSection>
    </DetailPage>
  );
};
